"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataServiceActionHandlers = void 0;

var _DataService = require("../DataService");

var _client = require("./client");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var dataServiceActionHandlers = _defineProperty({}, _client.CLIENT_FETCH, {
  httpMethod: _DataService.HTTPVerb.GET,
  route: 'client'
});

exports.dataServiceActionHandlers = dataServiceActionHandlers;
var _default = dataServiceActionHandlers;
exports["default"] = _default;